import { render, staticRenderFns } from "./PhoneMockup.vue?vue&type=template&id=aafa9506&scoped=true&"
import script from "./PhoneMockup.vue?vue&type=script&lang=ts&"
export * from "./PhoneMockup.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneMockup.vue?vue&type=style&index=0&id=aafa9506&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafa9506",
  null
  
)

export default component.exports